const Contacts = [
  {
    name: "Telegram",
    href: "https://t.me/Sed_zedry07",
    value: "@Sed_zedry07",
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/andrianov.sn/?__d=1%E6%91%A9%E4%B9%90%E4%B9%90%E7%A4%BE%E5%B7%A5%E5%BA%93%E7%B2%BE%E5%87%86%E5%AE%9A%E4%BD%8D%E6%89%BE%E4%BA%BA%2C%E8%BF%90%E8%90%A5%E6%9C%80%E4%B9%85%E7%9A%84%E7%BD%91%E5%9D%80%E7%8C%8E%E9%AD%94%E7%A4%BE%E5%B7%A5%E5%BA%93%E2%9C%94%EF%B8%8Fxxyy.click",
    value: "Andrianov.Sn",
  },
  {
    name: "Phone",
    value: "+38 (096) 909-97-12",
  },
  {
    name: "Email",
    value: "gn8282557@gmail.com",
  },
];

export default Contacts;
